import { render, staticRenderFns } from "./Warranty.vue?vue&type=template&id=379af2c8&scoped=true"
import script from "./Warranty.vue?vue&type=script&lang=js"
export * from "./Warranty.vue?vue&type=script&lang=js"
import style0 from "./Warranty.vue?vue&type=style&index=0&id=379af2c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379af2c8",
  null
  
)

export default component.exports